export default "__VITE_ASSET__kQG_D6Od__"